import { render, staticRenderFns } from "./ProductAddonGroup.vue?vue&type=template&id=67e7b1c9&"
import script from "./ProductAddonGroup.vue?vue&type=script&lang=js&"
export * from "./ProductAddonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports